export const cowsChapterList = [
    {
        title: "Молочное животноводство",
        Image: "/assets/img/cows/cow.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-13px, -26px)" },
    },
    {
        title: "Мясное животноводство",
        Image: "/assets/img/cows/bull.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-14px, -33px)" },
    },
    {
        title: "Козы",
        Image: "/assets/img/cows/goat.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Овцы",
        Image: "/assets/img/cows/sheep.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Молочное животноводство",
        Image: "/assets/img/cows/cow.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-13px, -26px)" },
    },
    {
        title: "Мясное животноводство",
        Image: "/assets/img/cows/bull.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-14px, -33px)" },
    },
    {
        title: "Козы",
        Image: "/assets/img/cows/goat.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Овцы",
        Image: "/assets/img/cows/sheep.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Молочное животноводство",
        Image: "/assets/img/cows/cow.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-13px, -26px)" },
    },
    {
        title: "Мясное животноводство",
        Image: "/assets/img/cows/bull.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-14px, -33px)" },
    },
    {
        title: "Козы",
        Image: "/assets/img/cows/goat.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Овцы",
        Image: "/assets/img/cows/sheep.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Молочное животноводство",
        Image: "/assets/img/cows/cow.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-13px, -26px)" },
    },
    {
        title: "Мясное животноводство",
        Image: "/assets/img/cows/bull.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-14px, -33px)" },
    },
    {
        title: "Козы",
        Image: "/assets/img/cows/goat.png",
        value: "для кого",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    },
    {
        title: "Овцы",
        Image: "/assets/img/cows/sheep.png",
        value: "специализация",
        link: "/catalog",
        style: { transform: "translate(-20px, -24px)" },
    }
]

export const birdsChapterList = [
    {
        title: "Бройлерное птицеводство",
        Image: "/assets/img/birds/broiler.png",
        value: "для кого",
        link: "/useful-meterials",
        style: { transform: "translate(10px, 30px) scale(1.3)", opacity: 1 },
    },
    {
        title: "Яичное птицеводство",
        Image: "/assets/img/birds/chicken.png",
        value: "специализация",
        link: "/useful-meterials",
        style: { transform: "translate(10px, 14px) scale(1.3)", opacity: 1 }
    },
    {
        title: "Индейководство",
        Image: "/assets/img/birds/turkey.png",
        value: "для кого",
        link: "/useful-meterials",
        style: { transform: "translate(49px, -21px) scale(1.6)", opacity: 1 },
    },
    {
        title: "Перепеловодство",
        Image: "/assets/img/birds/quail.png",
        value: "специализация",
        link: "/useful-meterials",
        style: { transform: "translate(30px, 21px) scale(1.6)", opacity: 1 },
    },
    {
        title: "Бройлерное птицеводство",
        Image: "/assets/img/birds/broiler.png",
        value: "для кого",
        link: "/useful-meterials",
        style: { transform: "translate(10px, 30px) scale(1.3)", opacity: 1 },
    },
    {
        title: "Яичное птицеводство",
        Image: "/assets/img/birds/chicken.png",
        value: "специализация",
        link: "/useful-meterials",
        style: { transform: "translate(10px, 14px) scale(1.3)", opacity: 1 }
    },
    {
        title: "Индейководство",
        Image: "/assets/img/birds/turkey.png",
        value: "для кого",
        link: "/useful-meterials",
        style: { transform: "translate(49px, -21px) scale(1.6)", opacity: 1 },
    },
    {
        title: "Перепеловодство",
        Image: "/assets/img/birds/quail.png",
        value: "специализация",
        link: "/useful-meterials",
        style: { transform: "translate(30px, 21px) scale(1.6)", opacity: 1 },
    }
]

export const pigsChapterList = [
    {
        title: "Свиньи",
        Image: "/assets/img/pigs/pig.png",
        value: "для кого"
    },
    {
        title: "Что-то про свиней",
        Image: "/assets/img/pigs/pig.png",
        value: "специализация"
    },
    {
        title: "Кожа",
        Image: "/assets/img/pigs/pig.png",
        value: "для кого"
    },
    {
        title: "Свинина",
        Image: "/assets/img/pigs/pig.png",
        value: "специализация"
    },
    {
        title: "Свиньи",
        Image: "/assets/img/pigs/pig.png",
        value: "для кого"
    },
    {
        title: "Что-то про свиней",
        Image: "/assets/img/pigs/pig.png",
        value: "специализация"
    },
    {
        title: "Кожа",
        Image: "/assets/img/pigs/pig.png",
        value: "для кого"
    },
    {
        title: "Свинина",
        Image: "/assets/img/pigs/pig.png",
        value: "специализация"
    }
]